import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import { Box } from '@indeed/ifl-components';
import { sxProp } from '@indeed/ifl-css';
import { ChevronLeft } from '@indeed/ifl-icons';
import IndeedLogo from 'Components/IndeedLogo';
import HomeIcon from 'Icons/HomeIcon';
import { style } from './_HeaderContent.jss';
import './_HeaderContent.scss';
export default function HeaderContent({ type, title, prevPage, onClickBack, isGlobalNavBar }) {
    const backButton = (React.createElement(Fragment, null,
        React.createElement(ChevronLeft, { size: "md", title: "\u623B\u308B", color: "inheritColor" }),
        "\u623B\u308B"));
    const theme = useTheme();
    if (type === 'nav') {
        const backButtonClassName = classNames('HeaderContent-backButton', {
            disabled: !prevPage && !onClickBack
        });
        return (React.createElement(Fragment, null,
            !onClickBack ? (React.createElement(Link, { to: prevPage || '', className: classNames(backButtonClassName, css(sxProp({ sx: style.backButton, theme }))) }, backButton)) : (React.createElement(Box, { as: "button", onClick: onClickBack, className: backButtonClassName, sx: style.backButton }, backButton)),
            React.createElement("div", { className: "HeaderContent-title" }, title),
            !isGlobalNavBar && (React.createElement(Link, { to: "/home", className: "HeaderContent-homeIcon" },
                React.createElement("div", null,
                    React.createElement(HomeIcon, null)),
                React.createElement("span", null, "\u30DB\u30FC\u30E0")))));
    }
    if (type === 'preview' || type === 'onboarding') {
        const backButtonClassName = classNames('HeaderContent-backButton', {
            disabled: !prevPage && !onClickBack
        });
        return (React.createElement(Fragment, null,
            !onClickBack ? (React.createElement(Link, { to: prevPage || '', className: backButtonClassName }, backButton)) : (React.createElement(Box, { as: "button", onClick: onClickBack, sx: style.backButton, className: backButtonClassName }, backButton)),
            React.createElement("div", { className: "HeaderContent-title" }, title),
            React.createElement("div", { className: "HeaderContent-right" })));
    }
    if (type === 'camera') {
        return (React.createElement(Fragment, null,
            React.createElement(Box, { as: "button", onClick: onClickBack, sx: style.backButton, className: classNames('HeaderContent-backButton', {
                    disabled: !onClickBack
                }) }, backButton),
            React.createElement("div", { className: "HeaderContent-title" }, "\u5C65\u6B74\u66F8\u30AB\u30E1\u30E9")));
    }
    return (React.createElement("div", { className: "HeaderContent-logoContainer" },
        React.createElement(IndeedLogo, { title: "\u30A4\u30F3\u30C7\u30FC\u30C9", desc: "\u30A4\u30F3\u30C7\u30FC\u30C9", style: { height: '21px' } })));
}
